import React, { useState,useEffect } from "react";
import styled from "styled-components";

const CheckTC = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

const TermsAndConditions = (props) => {
  const { conditions } = props;
  let terms=null;
 if(conditions === ""){
     terms =`I have read and understood the <b>   <a target="_blank" href="https://webassets.rbl.bank.in/document/pdfs/credit-card-member-declaration.pdf">Card Member Declaration</a></b>,
     the <b><a target="_blank" href="https://webassets.rbl.bank.in/document/Credit%20Cards/RBL-MITC-final.pdf">Most Important Terms & Conditions</a></b> 
     and agree with the same.I authorize RBL Bank and its representatives to call or SMS me with reference to my Credit Card application.
     I understand that the digital trail of the entire process of applying for the Credit Card has been duly approved and authenticated by me 
     through One Time Password (OTP) method and the digital trail shall be maintained by RBL Bank, which shall be the sole and binding evidence on the application, 
     utilization and my obligation to re-pay all outstanding amounts as per the Card Member Agreement. I further understand that RBL Bank will reach out to me for completing 
     the KYC via Aadhaar OTP, OKYC, Bio-metric KYC process or through Video KYC.`
 }
  const [checked, setChecked] = useState(false);
  const [showText, setShowText] = useState(true);
  const readText = () => {
    setShowText(!showText);
  };
  useEffect(() => {
    document.querySelectorAll(".buttonProceed")[0].classList.add("disabledButtonProceed");
    document.querySelectorAll(".buttonProceed")[1].classList.add("disabledButtonProceed");
  }, []);
const handleProceed = (event, value) => {
    let item = event.target.parentElement;
    let checkbox = item.querySelector("#terms-and-conditions");
    let inputString = "Continue" + "<split>" + value;
    if (checkbox && checkbox.checked) {
      window["autosubmit"](inputString);
      document.getElementById("check-term").style.pointerEvents = "none";
      if (value.includes("Yes")) {
        event.target.classList.add("disabledButtonProceed");
        event.target.nextElementSibling.classList.add("disabledButtonProceed");
      } else {
        event.target.classList.add("disabledButtonProceed");
        event.target.previousElementSibling.classList.add(
          "disabledButtonProceed"
        );
      }
    } else {
      props.overlayMessageToggle(
        "Please read carefully and agree to the Terms and Conditions"
      );
    }
  };
  const handleCheck = (ev) => {
    setChecked(!checked);
    if (ev.target.checked) {
      ev.target.parentElement.nextElementSibling.classList.remove(
        "disabledButtonProceed"
      );
      ev.target.parentElement.nextElementSibling.nextElementSibling.classList.remove(
        "disabledButtonProceed"
      );
    } else {
      ev.target.parentElement.nextElementSibling.classList.add(
        "disabledButtonProceed"
      );
      ev.target.parentElement.nextElementSibling.nextElementSibling.classList.add(
        "disabledButtonProceed"
      );
    }
  };

  return (
    <div id="check-term">
      <CheckTC>
        <input checked={checked}
          type="checkbox"
          id="terms-and-conditions"
          onChange={(ev) => handleCheck(ev)}
        />
        {showText ? (
          <div><span dangerouslySetInnerHTML={{__html: terms.substring(0, 160) + "...",}}></span>
          <a onClick={readText}>Read more</a>
          </div>
        ) : (
          <div>
            <span dangerouslySetInnerHTML={{__html: terms}}></span>
            <a onClick={readText}>Read less</a>
          </div>
        )}
      </CheckTC>
      <div
        className="buttonProceed disable-item"
        onClick={() => handleProceed(event, "Yes, that is my current address")}
      >
       Yes, that is my current address
      </div>
      <div className="buttonProceed disable-item" onClick={() => handleProceed(event, "No, my current Address has changed")}>
      No, my current Address has changed
      </div>
    </div>
  );
};
export default TermsAndConditions;
